import React, { useContext } from "react";

const AppContext = React.createContext();

function useAppContext() {
  const context = useContext(AppContext);

  const permissions = context?.permissions;
  let parsedPermissions;

  if (typeof permissions === 'string') {
    try {
      const parsedObject = JSON.parse(permissions);
      parsedPermissions = Object.keys(parsedObject);
    } catch (error) {
      parsedPermissions = [];
    }
  } else {
    parsedPermissions = permissions || [];
  }
  return {
    ...context,
    permissions: parsedPermissions,
  };
}

export { AppContext, useAppContext };
